import React, { useCallback, useMemo, useState } from 'react'
import { ActivityIndicator, FlatList } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'
import useLanguageStore from '@zet/localization/store/language'
import { UpcomingTrainingItem } from '@zet/utils/interface'

import { useEnrollToTraining, useUpcomingTrainings } from '../../../../api'
import RenderEnrollCards from '../enrollCards'

const GrowKnowledge = ({
  brandTrenning,
  isBrandTraining = false,
}: {
  brandTrenning?: any
  isBrandTraining?: boolean
}) => {
  const { data } = useUpcomingTrainings('upcoming', '')
  const { isLoading: isButtonLoading } = useEnrollToTraining()
  const { locale } = useLanguageStore((state) => state)
  const [trainingList, setTrainingList] = useState<UpcomingTrainingItem[]>([])

  useMemo(() => {
    const temp: React.SetStateAction<UpcomingTrainingItem[]> = []
    const tempTrainingData = brandTrenning ? brandTrenning : data
    tempTrainingData?.webinars?.forEach?.((value: any) =>
      temp.push({
        id: value.id,
        imageURI: value.banner,
        title: value.title,
        isEnrolled: value.status === 'UNREGISTERED' ? false : true,
        language: value.locale === 'hi' ? 'Hindi' : 'English',
        link: value.link,
        isButtonLoading: isButtonLoading,
        startTime: value.startTime / 1000,
        status: value.status,
        isBlocked: value.isBlocked || false,
      })
    )
    setTrainingList(temp)
  }, [brandTrenning, data, isButtonLoading])
  console.log('GrowKnowledge', data)

  const renderHeading = useCallback(
    () => (
      <SH3 className="mb-3">
        {isBrandTraining
          ? i18n.t('brandGrowKnowledge')
          : i18n.t('growKnowledge')}
      </SH3>
    ),
    [locale]
  )

  if (!isButtonLoading && !trainingList.length) {
    return <></>
  }

  return (
    <Stack className="bg-grays-20 mb-3  mt-3 py-3 pl-3">
      {renderHeading()}
      <FlatList
        data={trainingList}
        ListEmptyComponent={<ActivityIndicator size={'large'} />}
        renderItem={({ item, index }) => (
          <RenderEnrollCards
            item={item}
            keyIndex={index}
            trainingList={trainingList}
          />
        )}
        keyExtractor={(item) => item.id}
        horizontal={true}
        showsHorizontalScrollIndicator={false}
      />
    </Stack>
  )
}

export default React.memo(GrowKnowledge)
